import { useState, useEffect } from 'react';
import classnames from 'classnames';
import { useWallet } from '@suiet/wallet-kit';
import { addressEllipsis } from '@suiet/wallet-sdk';
import { getSuiNsName } from '../../utils';
import { useSuiClient } from '@mysten/dapp-kit';

export const CustomWalletInfo = (props: any) => {
  const { disconnect, account, connected, name } = useWallet();
  const [showDisconnectButton, setShowDisconnectButton] = useState(false);
  const [suiNsName, setSuiNsName] = useState<string | undefined>(undefined);
  const provider = useSuiClient();

  useEffect(() => {
    const fetchSuiNsName = async () => {
      if (account?.address) {
        try {
          const name = await getSuiNsName(provider, account.address);
          setSuiNsName(name);
        } catch (error) {
          console.error('Error fetching SuiNS name:', error);
          setSuiNsName(undefined);
        }
      }
    };

    fetchSuiNsName();
  }, [account?.address]);

  const containerStyle = {
    ...props.style,
    border: '1px solid #00ff9d',
    transition: 'box-shadow 0.3s ease-in-out',
    ...(suiNsName
      ? {
          boxShadow:
            '0 0 10px #00ff9d, 0 0 20px #00ff9d, inset 0 0 10px #00ff9d',
        }
      : {}),
  };

  if (!connected) return null;

  return (
    <div
      className={classnames('wkit-connected-container', props.className)}
      style={containerStyle}
    >
      <button
        className={classnames('wkit-connected-button')}
        onClick={() => setShowDisconnectButton(!showDisconnectButton)}
      >
        <div className={'wkit-connected-button__divider'}></div>
        <div className={'wkit-address-select'}>
          <span className={'wkit-address-select__address'}>
            {suiNsName || addressEllipsis(account?.address ?? '')}
          </span>
        </div>
      </button>
      {showDisconnectButton && (
        <div className="wkit-disconnect-button__container">
          <button
            className={'wkit-disconnect-button'}
            onClick={async () => {
              setShowDisconnectButton(false);
              try {
                await disconnect();
              } catch (e) {
                props?.onDisconnectError?.(e);
                return;
              }
              props?.onDisconnectSuccess?.(name);
            }}
          >
            Disconnect
          </button>
        </div>
      )}
    </div>
  );
};

export default CustomWalletInfo;
